var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1325 0.6275C19.6225 1.1175 19.6225 1.9075 19.1325 2.3975L10.8225 10.7075C10.4325 11.0975 9.8025 11.0975 9.4125 10.7075L1.1025 2.3975C0.612499 1.9075 0.612499 1.1175 1.1025 0.6275C1.5925 0.137501 2.3825 0.137501 2.8725 0.6275L10.1225 7.8675L17.3725 0.617501C17.8525 0.137502 18.6525 0.1375 19.1325 0.6275Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAyMCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjEzMjUgMC42Mjc1QzE5LjYyMjUgMS4xMTc1IDE5LjYyMjUgMS45MDc1IDE5LjEzMjUgMi4zOTc1TDEwLjgyMjUgMTAuNzA3NUMxMC40MzI1IDExLjA5NzUgOS44MDI1IDExLjA5NzUgOS40MTI1IDEwLjcwNzVMMS4xMDI1IDIuMzk3NUMwLjYxMjQ5OSAxLjkwNzUgMC42MTI0OTkgMS4xMTc1IDEuMTAyNSAwLjYyNzVDMS41OTI1IDAuMTM3NTAxIDIuMzgyNSAwLjEzNzUwMSAyLjg3MjUgMC42Mjc1TDEwLjEyMjUgNy44Njc1TDE3LjM3MjUgMC42MTc1MDFDMTcuODUyNSAwLjEzNzUwMiAxOC42NTI1IDAuMTM3NSAxOS4xMzI1IDAuNjI3NVoiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };